<template>
  <div class="bridgeDetails">
    <div class="bridge-details-hero">
      <div class="bridge-details-hero-main">
        <span class="bridge-details-eyebrow">CHARGING PILE DETAIL</span>
        <h2>电桩详情</h2>
        <p>查看充电桩基础信息、归属站点、设备规格与费率配置。</p>
      </div>
      <div class="bridge-details-hero-side">
        <div class="bridge-details-summary">
          <div class="bridge-details-summary-item">
            <span>设备类型</span>
            <strong>{{ dateDetails.ormtb602ca06 == 1 ? '直流' : '交流' }}</strong>
          </div>
          <div class="bridge-details-summary-item">
            <span>设备功率</span>
            <strong>{{ dateDetails.ormtb602ca04 || '--' }}</strong>
          </div>
          <div class="bridge-details-summary-item">
            <span>枪口数</span>
            <strong>{{ dateDetails.ormtb602ca05 || '--' }}</strong>
          </div>
        </div>
        <el-button
          @click="back"
          class="back_btn"
          type="primary"
          icon="el-icon-back"
          >返回上一级</el-button
        >
      </div>
    </div>

    <el-card class="box-card bridge-details-card">
      <div slot="header" class="clearfix bridge-details-header">
        <span>基础信息</span>
      </div>
      <div class="bridge-details-grid">
        <div class="bridge-details-item bridge-details-item-primary">
          <span>设备名称</span>
          <strong>{{ dateDetails.ormtb602ca03 || '--' }}</strong>
        </div>
        <div class="bridge-details-item bridge-details-item-rate">
          <span>计费规则</span>
          <strong>{{ dateDetails.ormtb608ca01 || '--' }}</strong>
        </div>
        <div class="bridge-details-item">
          <span>设备编码</span>
          <strong>{{ dateDetails.ormtb602ca00 || '--' }}</strong>
        </div>
        <div class="bridge-details-item">
          <span>电桩类型</span>
          <strong>{{ dateDetails.ormtb602ca06 == 1 ? '直流设备' : '交流设备' }}</strong>
        </div>
        <div class="bridge-details-item">
          <span>所属电站</span>
          <strong>{{ dateDetails.ormtb601ca00 || '--' }}</strong>
        </div>
        <div class="bridge-details-item">
          <span>所属厂家</span>
          <strong>{{ dateDetails.ormtb602ca01 == 'JS' ? '嘉胜' : '金冠' }}</strong>
        </div>
        <div class="bridge-details-item">
          <span>设备功率</span>
          <strong>{{ dateDetails.ormtb602ca04 ? dateDetails.ormtb602ca04 + '(Kw)' : '--' }}</strong>
        </div>
        <div class="bridge-details-item">
          <span>枪口数量</span>
          <strong>{{ dateDetails.ormtb602ca05 || '--' }}</strong>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dateDetails: {},
    }
  },
  mounted() {
    console.log(this.$route.query.id)
    let ids = { ormtb602id: this.$route.query.id }
    let url = 'orm/ormtb602/select602Detail'
    this.axios.post(url, ids).then(res => {
      if (res.data.code == 200) {
        console.log('电桩详情', res.data.data)
        this.dateDetails = res.data.data
      }
    })
    // this.dateDetails = JSON.parse(this.$route.query.ormtb602id)
  },
  methods: {
    back() {
      this.$router.back()
    },
  },
}
</script>

<style scoped>
.bridgeDetails {
  min-height: 100%;
  padding: 18px;
  background:
    radial-gradient(circle at 12% 8%, rgba(25, 159, 255, 0.12) 0, rgba(25, 159, 255, 0) 28%),
    linear-gradient(180deg, #f7fbff 0%, #edf5fb 100%);
  box-sizing: border-box;
  color: #25384d;
}

.bridge-details-hero {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 22px;
  margin-bottom: 18px;
  padding: 24px;
  border: 1px solid rgba(188, 222, 236, 0.95);
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.94) 0%, rgba(242, 251, 255, 0.94) 54%, rgba(238, 248, 244, 0.94) 100%);
  box-shadow: 0 16px 42px rgba(26, 99, 134, 0.11);
  box-sizing: border-box;
  overflow: hidden;
}

.bridge-details-hero::after {
  content: '';
  position: absolute;
  right: -54px;
  top: -72px;
  width: 210px;
  height: 210px;
  border-radius: 50%;
  background: rgba(25, 159, 255, 0.10);
}

.bridge-details-hero-main {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.bridge-details-eyebrow {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(25, 159, 255, 0.12);
  color: #1473b3;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.bridge-details-hero h2 {
  margin: 0;
  color: #17324d;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 1px;
}

.bridge-details-hero p {
  margin: 8px 0 0;
  color: #60758a;
  font-size: 13px;
  line-height: 1.6;
}

.bridge-details-hero-side {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
}

.bridge-details-summary {
  display: flex;
  gap: 12px;
}

.bridge-details-summary-item {
  min-width: 86px;
  padding: 12px 14px;
  border: 1px solid rgba(203, 226, 236, 0.92);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 8px 20px rgba(26, 99, 134, 0.08);
  text-align: center;
  box-sizing: border-box;
}

.bridge-details-summary-item span {
  display: block;
  color: #6d8194;
  font-size: 12px;
}

.bridge-details-summary-item strong {
  display: block;
  margin-top: 6px;
  color: #1473b3;
  font-size: 20px;
  line-height: 1;
}

.bridge-details-card {
  width: 100%;
  border: 1px solid rgba(216, 232, 238, 0.96);
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 14px 34px rgba(26, 99, 134, 0.09);
  overflow: hidden;
}

::v-deep .bridge-details-card .el-card__header {
  padding: 20px 22px;
  border-bottom: 1px solid rgba(216, 232, 238, 0.95);
  background: linear-gradient(180deg, #ffffff 0%, #f8fcff 100%);
}

::v-deep .bridge-details-card .el-card__body {
  padding: 22px;
}

.bridge-details-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bridge-details-header > span {
  position: relative;
  padding-left: 12px;
  color: #17324d;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 1px;
}

.bridge-details-header > span::before {
  content: '';
  position: absolute;
  top: 3px;
  left: 0;
  width: 4px;
  height: 16px;
  border-radius: 999px;
  background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%);
}

.bridge-details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.bridge-details-item {
  position: relative;
  min-height: 86px;
  padding: 18px 20px;
  border: 1px solid rgba(216, 232, 238, 0.95);
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fcff 100%);
  box-shadow: 0 8px 18px rgba(26, 99, 134, 0.05);
  box-sizing: border-box;
  overflow: hidden;
}

.bridge-details-item::after {
  content: '';
  position: absolute;
  right: -26px;
  bottom: -34px;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: rgba(25, 159, 255, 0.06);
}

.bridge-details-item-primary {
  border-color: rgba(25, 159, 255, 0.28);
  background: linear-gradient(135deg, #ffffff 0%, #eef8ff 100%);
}

.bridge-details-item-rate {
  border-color: rgba(14, 159, 110, 0.22);
  background: linear-gradient(135deg, #ffffff 0%, #eefbf5 100%);
}

.bridge-details-item span {
  position: relative;
  z-index: 1;
  display: block;
  margin-bottom: 10px;
  color: #6b7e90;
  font-size: 13px;
  line-height: 1;
}

.bridge-details-item strong {
  position: relative;
  z-index: 1;
  display: block;
  color: #17324d;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  word-break: break-all;
}

.back_btn {
  flex-shrink: 0;
  float: none;
  border: none;
  border-radius: 999px;
  background: linear-gradient(180deg, #4aaee8 0%, #199fff 100%);
  color: #fff;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(25, 159, 255, 0.24);
}

.back_btn:hover,
.back_btn:focus {
  background: linear-gradient(180deg, #5bb8ee 0%, #148adf 100%);
  color: #fff;
}

::v-deep .name-header {
  background-color: #e6a23c !important;
}

@media screen and (max-width: 900px) {
  .bridge-details-hero {
    align-items: flex-start;
    flex-direction: column;
  }

  .bridge-details-hero-side {
    align-items: flex-start;
    width: 100%;
  }

  .bridge-details-summary {
    flex-wrap: wrap;
  }

  .bridge-details-grid {
    grid-template-columns: 1fr;
  }
}
</style>
